import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/multiLocationOverviewSaga";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";

const GroupBy = () => {
  const dispatch = useDispatch();
  const { filters, label, value } = useSelector((state) => state.multiLocationOverview.groupBy);

  return (
    <div className="select-box" style={{ width: 175 }}>
      <p>{label}</p>
      <MultiSelectDropdown
        options={filters}
        selectedFilters={value}
        includeFilter={false}
        placeholder="Select group"
        onSelectChange={(data) => dispatch(actionCreators.updateGroupBy(data))}
      />
    </div>
  );
};

export default GroupBy;
